import { DropdownMenuItem } from "@/components/podkit/dropdown/DropDown";
import { DropdownActions } from "@/components/podkit/dropdown/DropDownActions";
import { useState, type FC } from "react";
import { Button } from "@/components/flexkit/Button";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { useAgentExecutionActions } from "@/hooks/use-agent-execution-actions";
import { ViewTranscriptModal } from "@/components/ai/ViewTranscriptModal";
import { AgentExecution_Phase } from "gitpod-next-api/gitpod/v1/agent_pb";
import { IconEllipsisHorizontal } from "@/assets/icons/geist/IconEllipsisHorizontal";

type EnvironmentOnboardingDropdownMenuProps = {
    onClickViewConversation: () => void;
    agentExecution: PlainAgentExecution;
};

export const EnvironmentOnboardingDropdownMenu: FC<EnvironmentOnboardingDropdownMenuProps> = ({
    agentExecution,
    onClickViewConversation,
}) => {
    const [showViewTranscriptModal, setShowViewTranscriptModal] = useState(false);
    const { copyAgentExecutionId, handleStopAgentExecution } = useAgentExecutionActions(agentExecution);
    return (
        <>
            <DropdownActions
                triggerTestId="environment-onboarding-options-trigger"
                button={
                    <Button
                        size="sm"
                        variant="ghost"
                        className="border-0"
                        aria-label="More actions"
                        LeadingIcon={IconEllipsisHorizontal}
                    />
                }
            >
                <DropdownMenuItem data-testid="menu-item-copy-agent-execution-id" onClick={copyAgentExecutionId}>
                    Copy agent execution ID
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="menu-item-view-conversation" onClick={onClickViewConversation}>
                    View conversation
                </DropdownMenuItem>
                <DropdownMenuItem
                    data-testid="menu-item-view-transcript"
                    onClick={() => setShowViewTranscriptModal(true)}
                >
                    View transcript
                </DropdownMenuItem>
                <DropdownMenuItem
                    data-testid="menu-item-stop-agent-execution"
                    onClick={handleStopAgentExecution}
                    disabled={agentExecution.status?.phase === AgentExecution_Phase.STOPPED}
                >
                    Stop agent execution
                </DropdownMenuItem>
            </DropdownActions>
            <ViewTranscriptModal
                agentExecution={agentExecution}
                open={showViewTranscriptModal}
                onClose={() => setShowViewTranscriptModal(false)}
            />
        </>
    );
};
